<ng-container *ngIf="!landDirectlyOnInputField">
  <form #expandingSearchForm="ngForm" novalidate class="form">
    <div class="expanding-search-container">
      <i *ngIf="!noSearch" class="material-icons search-icon" appDisableFeature [pathString]="pathString"
        (click)="expanded=true; focus()" [ngClass]="{'d-none': expanded}">
        search
      </i>
      <mat-form-field class="medium" [ngClass]="{'expanded': expanded}">
        <input matInput type="text" name="search" placeholder="{{placeholder || 'Search'}}"
          [errorStateMatcher]="matcher" [ngModel]="model" #search required="{{required}}" pattern="{{regExp}}"
          (ngModelChange)="valueChange($event, search)" cdkFocusInitial>
        <button type="button" mat-button *ngIf="expanded" matSuffix mat-icon-button aria-label="Clear"
        (click)="clearInputField()">
          <mat-icon>close</mat-icon>
        </button>
        <mat-error *ngIf="required && search?.errors?.required && search.touched">
          {{requiredErrorMessage}}
        </mat-error>
        <mat-error
          *ngIf="regExp && ((search.dirty || search.touched) || (search?.errors?.pattern || !search?.validity?.valid))">
          {{regExpErrorMessage}}
        </mat-error>
      </mat-form-field>
    </div>
  </form>
  <span class="search-label" *ngIf="!expanded && label" appDisableFeature [pathString]="pathString"
    (click)="expanded=true; focus()">{{label}}</span>
</ng-container>
<div *ngIf="landDirectlyOnInputField" class="expanding-search-table-form-container">
  <mat-form-field appearance="none" [style.width]="width">
    <div class="container">
      <i matPrefix class="material-icons search-icon icons">
        search
      </i>
      <input matInput type="text" name="search" placeholder="Search" [errorStateMatcher]="matcher" [ngModel]="model"
        #search required="{{required}}" pattern="{{regExp}}" (ngModelChange)="valueChange($event, search)"
        autocomplete="off">
      <i *ngIf="model && model.length" matSuffix class="material-icons icons"
      (click)="clearInputField()">
        close
      </i>
    </div>
    <mat-error *ngIf="required && search?.errors?.required && search.touched">
      {{requiredErrorMessage}}
    </mat-error>
    <mat-error
      *ngIf="regExp && ((search.dirty || search.touched) || (search?.errors?.pattern || !search?.validity?.valid))">
      {{regExpErrorMessage}}
    </mat-error>
  </mat-form-field>
</div>
